// eslint-disable-next-line import/no-named-as-default
import liff from "@line/liff";
import { Anchor, Button, Center, Stack, Text } from "@mantine/core";
import { useGetCurrentMember, usePostUsersGuests } from "api";
import MainLayout from "components/layouts/MainLayout";
import { useAtomValue } from "jotai";
import { PAGE_TITLE } from "libs/constants";
import { utmRequestParamsAtom } from "libs/jotai/atoms";
import { customNotifications } from "libs/mantine/customNotifications";
import type { FC } from "react";
import { useNavigate } from "react-router-dom";

/**
 * ゲスト会員登録ページ
 */
const SignupGuest: FC = () => {
  const navigate = useNavigate();
  const {
    mutate: mutateGetCurrentMember,
    isValidating: isValidatingGetCurrentMember
  } = useGetCurrentMember();
  const {
    trigger: triggerPostUsersGuests,
    isMutating: isMutatingPostUsersGuests
  } = usePostUsersGuests();
  const utmRequestParams = useAtomValue(utmRequestParamsAtom);

  // ゲスト会員登録ボタンクリックの処理
  const onClickGuestButton = () => {
    // utmRequestParamsにutm_contentが設定されていなければ "guest_page" を追加
    const requestParams = { ...utmRequestParams };
    if (!requestParams.utm_content) {
      requestParams.utm_content = "guest_page";
    }

    void triggerPostUsersGuests(requestParams, {
      onError: ({ errors }) =>
        customNotifications.show({ message: errors, status: "error" }),
      onSuccess: () =>
        void mutateGetCurrentMember().then(() => {
          customNotifications.show({
            message: "仮会員証を発行しました",
            status: "success"
          });
          navigate("/"); // ホームページへ
        }),
      throwOnError: false
    });
  };

  return (
    <MainLayout header footer={false} pageTitle={PAGE_TITLE.SIGNUP_GUEST}>
      <Stack spacing={32} mb={32}>
        {/* 説明書き */}
        <Text size="xl" weight="bold" ta="center">
          LINE会員証へようこそ
        </Text>
        {/* 会員規約テキスト */}
        <Center>
          <Text fw="bold" size="xl">
            <Anchor
              component="button"
              color="#3078E5"
              size="xl"
              fw="bold"
              onClick={() =>
                liff.openWindow({
                  external: false,
                  url: "https://www.royal-hc.co.jp/cardmember/code"
                })
              }
            >
              会員規約
            </Anchor>{" "}
            はこちら
          </Text>
        </Center>
        <Stack spacing="lg" pt={64}>
          {/* ゲスト会員登録ボタン */}
          <Button
            size="lg"
            fullWidth
            fz={20}
            loading={isMutatingPostUsersGuests || isValidatingGetCurrentMember}
            loaderPosition="center"
            onClick={onClickGuestButton}
            sx={{ height: "auto", padding: "8px 0" }}
          >
            <Text align="center">
              会員規約に同意して
              <br />
              はじめる
            </Text>
          </Button>
        </Stack>
      </Stack>
    </MainLayout>
  );
};

export default SignupGuest;
